<template>
	<div class="assistant-table assistant-table--empty" v-if="unit.name === 'smile-mini-04'">
		<h4 class="assistant-table__left-header">
			Dla unitu {{ unit.fullName }} nie ma możliwości konfigurowania stolika asysty.
		</h4>
		<img
			class="assistant-table__default-image"
			alt=""
			:src="require('@/assets/pictures/stolik-asysty-1.png')"
		/>
	</div>
	<div class="assistant-table" v-else>
		<div class="maincontent__double-header-wrapper">
			<div class="maincontent__double-header">
				<h2 class="maincontent__double-header-title">Stolik asysty</h2>
				<h2 class="maincontent__double-header-unit unit-model-header">
					<small>Unit stomatologiczny</small>
					<br />
					{{ unit.fullName }}
				</h2>
			</div>
		</div>
		<div class="assistant-table__columns">
			<div class="assistant-table__left">
				<div class="assistant-table__table-type">
					<h4 class="assistant-table__left-header">Rodzaj stolika asysty</h4>
					<small class="assistant-table__left-hint">
						Możesz wybrać jeden rodzaj:
					</small>
					<Radio
						v-for="(option, index) in assistantTableTypeOptions"
						:key="`assistant-table-type__${index}`"
						class="assistant-table__radio"
						name="assistant-table-type"
						:value="option.name"
						:checked="option.name === selectedAssistantTableType"
						@change="handleAssistantTableTypeChange"
					>
						<span class="addons__radio-label">
							{{ option.fullName }}
						</span>
						<span class="addons__radio-cost" slot="right-addon">
							{{ formatPrice(option.cost) }}
						</span>
					</Radio>
				</div>

				<div class="assistant-table__assistant-table">
					<h4 class="assistant-table__left-header">Elementy stolika asysty</h4>
					<small class="assistant-table__left-hint">
						Możesz wybrać dwie dodatkowe opcje. Za dodatkowe 3 i 4 miejsce na stoliku doliczona
						zostanie opłata.
					</small>
					<NumberedSelectGroup
						:forcedDisableItems="['ata-20', 'ata-21', 'ata-22']"
						:selects="assistantAccessorySelects"
						unitConfigurationProp="assistantTableAccessories"
						configurationPropSetter="setAssistantTableAccessories"
						:useOnlyFirstEnabledFeature="false"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as R from 'ramda';
import AppDataMixin from '@/mixins/app-data';
import {mapState} from 'vuex';
import {mapUnitConfiguration} from '@/core/helpers/map-unit-configuration.helpers';
import NumberedSelectGroup from '../NumberedSelectGroup';
import Radio from '@/components/Radio';

export default {
	name: 'AssistantTable',
	mixins: [AppDataMixin],
	data() {
		return {
			assistantAccessorySelects: [],
			assistantTableTypeOptions: [],
		};
	},
	components: {NumberedSelectGroup, Radio},
	computed: {
		...mapState('unitConfiguration', {
			accessories: 'physicianTableAccessories',
			selectedAssistantTableType: 'assistantTableType',
			waterSupplies: 'waterSupplies',
			assistantTableAccessories: 'assistantTableAccessories',
		}),
	},
	mounted() {
		const assistantAccessories = this.getAppData('assistantTableAccessories');

		this.setAssistantAccessorySelects();

		this.assistantTableTypeOptions = R.pipe(
			R.pickBy((_, key) => R.startsWith('at-type-', key)),
			R.values
		)(assistantAccessories);
	},
	methods: {
		handleAssistantTableTypeChange(assistantTableType) {
			if (assistantTableType) {
				this.$store.commit('unitConfiguration/setAssistantTableType', assistantTableType);
				this.setAssistantAccessorySelects();
			}
		},
		setAssistantAccessorySelects() {
			const assistantAccessories = this.getAppData('assistantTableAccessories');
			let count = 4;
			if (R.includes(this.unit.name, ['chirana-easy', 'chirana-l', 'chirana-effective'])) {
				if (this.selectedAssistantTableType === 'at-type-01') {
					count = 2;
				}
			}
			this.assistantAccessorySelects = R.times(
				i =>
					R.startsWith('ata-2', R.propOr('', i, this.assistantTableAccessories))
						? R.pipe(
								R.pickBy((_, key) => key === this.assistantTableAccessories[i]),
								R.values
						  )(assistantAccessories)
						: R.pipe(
								R.pickBy((_, key) => R.startsWith('ata-0', key)),
								R.values
						  )(assistantAccessories),
				count
			);
		},
	},
};
</script>
